// extracted by mini-css-extract-plugin
export default {"textarea-tag":"lsf-textarea-tag","textarea-tag__form":"lsf-textarea-tag__form","textarea-tag__form_hidden":"lsf-textarea-tag__form_hidden","textarea-tag__item":"lsf-textarea-tag__item","textarea-tag__input":"lsf-textarea-tag__input","textarea-tag__action":"lsf-textarea-tag__action"};
    if(module.hot) {
      // 1732531520934
      var cssReload = require("/home/kartik/kvr-lsf/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  